import React from 'react';
import ReactDOM from 'react-dom/client';
import { router } from 'components/Routes';
import { RouterProvider } from 'react-router-dom';
import { loadLanguage } from 'helpers/Language';

import 'normalize.css';
import 'styles/index.css';

loadLanguage();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);